import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 px-4">
      <h1 className="font-heading text-6xl text-primary-500 mb-4">404</h1>
      <p className="text-foreground-600 text-lg mb-8">抱歉，您访问的页面不存在</p>
      <Link
        to="/"
        className="px-6 py-3 bg-primary-500 text-white rounded-full font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors"
      >
        返回首页
      </Link>
    </div>
  );
}